import CustomerEmailEditor from './customer_email_editor';
import CustomerEmailDisplay from './customer_email_display';
import ClickToEditField from 'components/common/click_to_edit_field';

export default ClickToEditField(CustomerEmailDisplay, CustomerEmailEditor);
